// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oS5nf","largestCol":"styles_largestCol__1LQrj","smallestCol":"styles_smallestCol__18FsW"};